// import App from './App.svelte';
// import { mount } from "svelte";

// const app = mount(App, {
// 	target: document.querySelector(".rolls-app"),
// 	props: {
//     // rolls: [],
//     // categories: [],
//     // showModal: 0,
//     // searchterm: '',
//     // limit: 3
//   }
// });

// export default app;
//
import App from "./App.svelte";
import { mount } from "svelte";

const app = mount(App, {
  target: document.querySelector(".rolls-app"),
  props: {},
});

export default app;
